import { a as r, I as t, j as l, d as o } from "./IconTemplate-c24f5ddb.mjs";
import "react";
const s = (a) => /* @__PURE__ */ r(t, { ...a, name: a.name || "Tips", viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ l(
    "path",
    {
      d: "M530.65 456.17H425.54l-21.34 55.85h74.39l-38.18 210.13a34.97 34.97 0 0 0 34.38 41.22H579.9l21.34-55.85h-74.39l38.18-210.13a34.92 34.92 0 0 0-34.38-41.22M512 384a64 64 0 1 0 0-128 64 64 0 0 0 0 128",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  ),
  ",",
  /* @__PURE__ */ l(
    "path",
    {
      d: "M512 1024c282.77 0 512-229.23 512-512S794.77 0 512 0 0 229.23 0 512s229.23 512 512 512m0-85.33C276.35 938.67 85.33 747.65 85.33 512S276.35 85.33 512 85.33 938.67 276.35 938.67 512 747.65 938.67 512 938.67",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  )
] });
s.defaultProps = o;
export {
  s as default
};
